module.exports = __webpack_public_path__ + "img/more.4ba4c92b.svg";